import { lazy } from "react";

export { REQUESTS_ABSENCE_PATH } from "./requests-absence-path";

export const RequestAbsence = lazy(() => import("./requests-absence"));
